"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCustomerRecognitionForm = exports.ERROR_CONTEXT_KEY = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const js_cookie_1 = __importDefault(require("js-cookie"));
const react_1 = require("react");
const components_1 = require("../../components/index.js");
const utils_1 = require("../../utils/index.js");
const constants_1 = require("../../constants/index.js");
exports.ERROR_CONTEXT_KEY = 'useCustomerRecognitionForm';
const REQUIRED_PROPS = ['onSuccess'];
/**
 * @hook useCustomerRecognitionForm
 * @description Hook para realizar o fluxo de reconhecimento de cliente.
 *
 * [PARÂMETROS OBRIGATÓRIOS]
 *
 * @param {function} props.onSuccess Callback que será executada quando o formulário for enviado com sucesso.
 * @param {function} props.onTryAgain Caso haja erro no envio do formulário, o componente de erro será renderizado. Essa callback é executada quando o cliente clica no botão de tentar novamente.
 *
 * [RETORNO]
 *
 * O hook retorna um objeto contendo:
 *
 * @param Component
 * @description Componente de formulário que será renderizado na página.
 *
 * @param startRecognitionFlow
 * @description Função que inicia o fluxo de reconhecimento de cliente.
 *
 * @example
 *  const { Component, startRecognitionFlow } = useCustomerRecognitionForm({
 *   ComponentOptions: {
 *     type: "modal",
 *   },
 *   onSuccess: () => {
 *     console.log("Form submitted successfully!");
 *   },
 *   onTryAgain: () => {
 *     console.log("Trying again...");
 *   },
 *   onSkipSignup: () => {
 *     console.log("Skiping...");
 *   },
 * });
 */
const useCustomerRecognitionForm = (props) => {
    const [openModal, setOpenModal] = (0, react_1.useState)(false);
    (0, utils_1.checkRequiredProps)(props, REQUIRED_PROPS, exports.ERROR_CONTEXT_KEY);
    const { ComponentOptions, onSuccess, onTryAgain, onSkipSignup } = props;
    const { catalogName, formId, keepOpen, originIdentifier = '', type, enableCloseButton = true, } = ComponentOptions || {};
    const isModal = type === 'modal';
    const handleAutoClose = () => {
        if (isModal && !keepOpen) {
            setOpenModal(false);
        }
    };
    const handleSubmit = (token) => __awaiter(void 0, void 0, void 0, function* () {
        yield onSuccess(token);
        window.dispatchEvent(new Event(constants_1.EventCustomerRecognitionChange));
        handleAutoClose();
    });
    const handleSkip = () => {
        onSkipSignup === null || onSkipSignup === void 0 ? void 0 : onSkipSignup();
        handleAutoClose();
    };
    const handleTryAgain = () => {
        onTryAgain === null || onTryAgain === void 0 ? void 0 : onTryAgain();
        handleAutoClose();
    };
    const defaultProps = {
        formId,
        onSubmit: handleSubmit,
        onSkip: handleSkip,
        ErrorFeedbackProps: {
            onRetry: handleTryAgain,
            onContinue: handleSkip,
        },
    };
    let Component = function CustomerRecognitionForm(props) {
        return ((0, jsx_runtime_1.jsx)(components_1.CustomerRecognitionForm, Object.assign({ catalogName: catalogName, originIdentifier: originIdentifier }, defaultProps, props)));
    };
    if (isModal) {
        Component = function CustomerRecognitionFormModal(props) {
            return ((0, jsx_runtime_1.jsx)(components_1.CustomerRecognitionFormModal, Object.assign({ open: openModal, catalogName: catalogName, originIdentifier: originIdentifier, onClose: () => setOpenModal(false) }, defaultProps, props, { enableCloseButton: enableCloseButton })));
        };
    }
    const startRecognitionFlow = ({ customerCookieKey, isEnabled = true, }) => {
        const customerUuid = js_cookie_1.default.get(customerCookieKey);
        const shouldShowComponent = !customerUuid && isEnabled;
        if (isModal && shouldShowComponent) {
            setOpenModal(true);
        }
        else if (!shouldShowComponent) {
            onSkipSignup === null || onSkipSignup === void 0 ? void 0 : onSkipSignup();
        }
    };
    return {
        Component,
        startRecognitionFlow,
    };
};
exports.useCustomerRecognitionForm = useCustomerRecognitionForm;
